// The legacy Modal traps focus with react-focus-lock (via @reach/dialog). A
// popup that portals to document.body sits outside the lock's DOM subtree, so
// the lock yanks focus straight back out of it — arrow-key navigation inside a
// Menu opened from a Modal lands on the trigger instead of the next item.
//
// focus-lock reads `data-no-focus-lock` as its allow-list marker: while the
// active element is inside a node carrying it, the lock leaves focus alone
// (`focusIsHidden` in the focus-lock package). Outside a lock it does nothing.
//
// Spread onto the outermost portaled node of any popup that takes focus.
export const escapesFocusLock = { "data-no-focus-lock": "" } as const
